export default __webpack_public_path__ + "media/images/feature_reminder-55bbcb53782523f7e54ad24da581372b.png";